export const LISTING_VARIANTS = Object.freeze(['inline','minimal','compact','standard','editorial','featured']);
export const LEGACY_LISTING_VARIANTS = Object.freeze({ text:'minimal', bar:'compact', card:'standard', featured:'featured' });

export function normalizeListingVariant(value) {
  const variant = String(value || '').trim().toLowerCase();
  if (LISTING_VARIANTS.includes(variant)) return variant;
  return LEGACY_LISTING_VARIANTS[variant] || 'standard';
}

export const LISTING_VARIANT_PRESENTATION = Object.freeze({
  inline: Object.freeze({ media:false, description:false, compact:true }),
  minimal: Object.freeze({ media:false, description:true, compact:false }),
  compact: Object.freeze({ media:true, description:false, compact:true }),
  standard: Object.freeze({ media:true, description:true, compact:false }),
  editorial: Object.freeze({ media:true, description:true, compact:false }),
  featured: Object.freeze({ media:true, description:true, compact:false }),
});

export function listingVariantPresentation(value) {
  return LISTING_VARIANT_PRESENTATION[normalizeListingVariant(value)];
}

export function normalizeListingCardAttrs(attrs = {}) {
  return {
    schemaVersion:1, source:'listing', listingId:null, snapshot:null,
    variant:'standard', imageMode:'image', showCategory:true, showImage:true,
    showDescription:true, showAddress:true, showPhone:false, showRating:false,
    showLink:true, showCall:false, showWebsite:false, showDirections:false,
    linkLabel:'View listing', ...attrs, variant:normalizeListingVariant(attrs.variant),
  };
}
